<template>
    <!-- The offer the agent attached to the cart link. Read-only: a different offer means a new link.
         Drawn like the medication row above it, so its price explains the Due Today total. -->
    <div class="plan_div monthly">
        <div class="plandetails_div">
            <div v-if="image" class="image-488 offer-tile" :class="tileClass">
                <img :src="image" alt="" loading="lazy" class="offer-image" :class="fit && `offer-image--${fit}`">
            </div>
            <div class="planinfo-div">
                <div class="text-block-1066 offer-name">{{ name }}</div>
                <div class="text-block-1068">{{ subtitle }}</div>
                <div class="text-block-1070">{{ note }}</div>
            </div>
        </div>
        <div class="text-block-1071 offer-price">{{ priceLabel }}</div>
    </div>
</template>

<script>
import { offerLineName, offerPriceLabel, offerSubtitle, offerNote, offerImage } from '@/utils/cartOffer';
import { shopPictureFit } from '@/utils/shopImage';

export default {
    name: 'CartOfferRow',
    props: {
        offer: { type: Object, required: true },
        terms: { type: Number, required: true },
        // The plan box's tile colour class, so the offer picture sits on the same tile as the medication's.
        tileClass: { type: String, default: '' },
    },
    computed: {
        name() {
            return offerLineName(this.offer.line);
        },
        subtitle() {
            return offerSubtitle(this.offer);
        },
        note() {
            return offerNote(this.offer, this.terms);
        },
        priceLabel() {
            return offerPriceLabel(this.offer.line);
        },
        image() {
            return offerImage(this.offer.line);
        },
        fit() {
            return shopPictureFit(this.image);
        },
    },
};
</script>

<style scoped>
/* The tile is the medication picture's: 80px wide, coloured, rounded. */
.offer-tile {
    aspect-ratio: 1;
    flex-shrink: 0;
}

/* The offer pictures are cut-outs with no margin. The medication picture beside them
   is a square whose vial fills the middle 66% of its height, so pad 17% a side to
   draw the offer bottle the same size. The padding resolves against the tile, which
   is why the picture sits inside one rather than being the tile itself. */
.offer-image {
    display: block;
    width: 100%;
    height: 100%;
    padding: 17%;
    box-sizing: border-box;
    object-fit: contain;
}

/* The shop's redrawn vials (shop.rxpros.com/s) carry their own margin: the bottle fills 63% of an
   880x710 frame, which contain draws at 51% of the tile. Unpadded and 1.29x, it matches the 66%. */
.offer-image--vial {
    padding: 0;
    transform: scale(1.29);
}

/* The NAD+ Nasal spray fills 78% of the same frame and sits 8% above its middle, so 1.29x put its
   tip at the tile's top edge. Unpadded, moved down to centre it and 1.05x, it matches the 66%. */
.offer-image--spray {
    padding: 0;
    object-position: 50% 83%;
    transform: scale(1.05);
}

/* The checkout's own mobile size for the medication's name and price. */
@media screen and (max-width: 479px) {
    .offer-name,
    .offer-price {
        font-size: 20px;
    }
}
</style>
